
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.356 16.096l-1.875 2.343a19.777 19.777 0 01-7.029-7.029l2.344-1.874a1.593 1.593 0 00.46-1.89L8.12 2.837a1.593 1.593 0 00-1.857-.895L2.197 2.996a1.602 1.602 0 00-1.182 1.77 23.624 23.624 0 0020.11 20.11 1.602 1.602 0 001.77-1.183l1.054-4.066a1.592 1.592 0 00-.895-1.854l-4.809-2.136a1.593 1.593 0 00-1.89.459v0z","stroke":"#003C4A","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"square"}})])
          )
        }
      }
    